import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';
import _intersection from 'lodash/intersection';

export default class VisitorProfileAbility extends Ability {
  @service declare authz: AuthzService;

  /**
   * this.abilities.can('read visitor-profiles')
   */
  get canRead(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_VISITOR_PROFILE_READ);
  }

  /**
   * this.abilities.can('manage-note visitor-profiles')
   */
  get canManageNote(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_VISITOR_PROFILE_READ);
  }

  /**
   * this.abilities.can('read-screeners visitor-profile')
   *
   * Gates the RRC Screeners tab. Mirrors the backend, which authorizes
   * GET /visitor-profiles/:id/screener-summaries on the base visitor_profiles
   * read scope — so screener visibility tracks profile-read access.
   */
  get canReadScreeners(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_VISITOR_PROFILE_READ);
  }
}
